export const initialAddAuthState = {
    authorizedUserFirstName: { value: '', errorMessage: '', touched: false },
    authorizedUserLastName: { value: '', errorMessage: '', touched: false },
    authorizedUserBirthDate: { value: '', errorMessage: '', touched: false }
};
export const initialErrorDetails = {
    hasError: false,
    isBusinessError: false,
    businessErrorCode: '',
    businessErrorDescription: ''
};
